// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SYSTEM_POSITION_COL_TEMP_MODAL_CHANGE,
} from './constants';

export function positionColTempModalChange(visible) {
  return {
    type: SYSTEM_POSITION_COL_TEMP_MODAL_CHANGE,
    data: {visible},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_POSITION_COL_TEMP_MODAL_CHANGE:
      return {
        ...state,
        temModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/positionColTempModalChange.js